import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

const reservedSourcePropertyNames = [
    'type',
    'query',
    'additionalColumns',
    'datasetSettings',
    'changeReadStrategy'
];

const additionalSourcePropertiesControl: ControlMetadata = {
    type: 'key-val-list',
    bind: 'additionalFields',
    label: stringResources.ModelName_AdditionalPropertiesName,
    reservedKeys: reservedSourcePropertyNames
};

export const genericCDataTableMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.genericCData.datasetType,
    displayName: stringResources.GenericCData_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.genericCData.linkedServiceType],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-PlaceHolderDatabase'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    splitTablePath: true,
    schemaAlias: 'schema',
    tableAlias: 'table',
    schemaNameDisplay: stringResources.Schema,
    tableNameDisplay: stringResources.ModelName_Table,
    isTableNameRequired: true,
    notSupportPhysicalType: true,
    category: ['GenericProtocol'],
    copySourceControls: [additionalSourcePropertiesControl],
    copyJob: {
        multipleQuery: true,
        sourceControls: [additionalSourcePropertiesControl]
    }
};
